import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useWatchableRef } from 'lib/hooks'

function StructureArchivedModal(props) {
  const { open, onClose, address } = props
  const modalRef = useWatchableRef(null)

  useEffect(() => {
    if (!modalRef.current) return

    const localRefValue = modalRef.current
    const handleClose = (_e) => onClose()

    $(localRefValue).on('hidden.bs.modal', handleClose)
    return () => $(localRefValue).off('hidden.bs.modal', handleClose)
  }, [onClose, modalRef.version])

  useEffect(() => {
    if (!modalRef.current) return

    if (open) {
      $(modalRef.current).modal('show')
    } else {
      $(modalRef.current).modal('hide')
    }
  }, [open, modalRef.version])

  // TODO: Replace jQuery bootstrap modal with react-bootstrap modal when master-rentals branch gets merged.
  return (
    <div
      ref={modalRef.ref}
      className="modal dome-modal dome-modal-centered dome-modal-text-centered"
      tabIndex="-1"
      role="dialog"
    >
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-body">
            <i className="fa-thin fa-circle-check fa-3x dome-color-dark-green"></i>
            <div>
              <span className="dome-text-w500 dome-h2 dome-color-dark-green">{`${address} archived!`}</span>
            </div>
          </div>
          <div className="modal-footer">
            <button
              className="dome-btn dome-btn-base dome-btn-aqua-stroke"
              data-dismiss="modal"
              onClick={onClose}
              type="button"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

StructureArchivedModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  address: PropTypes.string.isRequired,
}

export default StructureArchivedModal
